<template>
 

    <div class="colorlib-error-page-area">
        <!-- Error Content -->
        <div class="error-content">
            <!-- Error Thumb -->
            <div class="erro-thumb">
                <img src="img/bg-img/bg.png" alt="">
            </div>
            <h2>Opps! ¡Esta página no se ha podido encontrar!</h2>
            <p>Lo siento, pero la página que busca no existe, ha sido eliminada o su nombre ha sido cambiado.</p>
           
        </div>
    </div>



</template>

<script>
export default {

}
</script>

<style>

</style>